// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__2QESN","logo":"nav_logo__nAwca","logoDisplay":"nav_logoDisplay__WHvyA","navWithLogo":"nav_navWithLogo__wf2tj"};